import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { contractStoreHandle } from '../../ContractStore/state/actions';
import { SearchOutlined } from "@ant-design/icons";
import { Empty, Modal, Select, Spin, Tooltip } from 'antd';
const { Option } = Select;

function DocsData({ values, handleSelectChange, existingValues, addClauseData, handleOk, handleCancel }) {
    const { addDocumentsData, addDocumentsError, addDocumentsLoading } = useSelector((state) => state.contractStore);
    const { rootDocData } = useSelector((state) => state.createOffer);
    // console.log('rootDocData', rootDocData);
    const dispatch = useDispatch();

    useEffect(() => {
      dispatch(contractStoreHandle.getAddDocumentsData(rootDocData?.token, ["SELLER", "BUYER"].includes(rootDocData?.openFor)));
    }, []);

    return (
        <Modal
            title={!addDocumentsData?.length && !addDocumentsLoading && !addDocumentsError ? `Looks like you don't have any Docs in your account!` : values?.value?.toUpperCase()}
            visible={true}
            onOk={handleOk}
            mask={true}
            closable={false}
            onCancel={handleCancel}
        >
            {addDocumentsLoading ? <div style={{textAlign: 'center'}}><Spin /></div> :
                addDocumentsError ? <Empty image={Empty.PRESENTED_IMAGE_SIMPLE}/> :
                    !addDocumentsData?.length ?
                        (<div>
                            Please go to "Tools", then click on "Docs/Clause". On the upper right hand corner click on the "+" button.
                            {/* <span>You can also refer below tutorial links.</span> */}
                        </div>) :
                        <>
                            <Select
                                // allowClear
                                style={{ width: "93%" }}
                                placeholder={values?.refName ? `Please select ${values.refName}` : "Please select"}
                                mode='multiple'
                                onChange={handleSelectChange}
                                value={existingValues}
                            >
                                {/* {addClauseData.map((el, i) => <Option style={{ zIndex: 12 }} key={el.name + i} value={el.name}>{el.name}</Option>)} */}
                                {addClauseData?.map((el, i) => (
                                    <Option style={{ zIndex: 12 }} key={el?.name + i} value={el?.name}>
                                        <Tooltip
                                            title={el?.name}
                                            placement="left"
                                            overlayStyle={{
                                                fontSize: '14px',
                                                // padding: '4px 8px',
                                            }}
                                            mouseEnterDelay={0}
                                        >
                                            <span>{el?.name}</span>
                                        </Tooltip>
                                    </Option>
                                ))}
                            </Select>
                            <SearchOutlined
                                style={{
                                    position: 'absolute',
                                    fontSize: "18px",
                                    cursor: 'pointer',
                                    top: '50%',
                                    transform: 'translateY(-50%)',
                                    right: '20px',
                                }}
                            />
                        </>
            }
        </Modal>
    )
}

export default DocsData
